"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mediaUpdate = exports.mediaThumbnailGet = exports.mediaThumbnail = exports.mediaSuccess = exports.mediaShow = exports.mediaReset = exports.mediaList = exports.mediaError = exports.mediaDelete = void 0;
var _media = require("./media.constant");
// common success
var mediaSuccess = function mediaSuccess(actionType, data) {
  return {
    type: _media.actionTypes.SUCCESS,
    payload: {
      actionType: actionType,
      data: data
    }
  };
};

// common error
exports.mediaSuccess = mediaSuccess;
var mediaError = function mediaError(actionType, error) {
  return {
    type: _media.actionTypes.ERROR,
    payload: {
      actionType: actionType,
      error: error
    }
  };
};

/**
 * Get api list
 * @param payload
 * @returns api response
 * @description this function used to get list.
 */
exports.mediaError = mediaError;
var mediaList = function mediaList(payload) {
  return {
    type: _media.actionTypes.LIST,
    payload: payload
  };
};

/**
 * cerate
 * @param payload
 * @returns api response
 * @description this function used to create.
 */
exports.mediaList = mediaList;
var mediaShow = function mediaShow(payload) {
  return {
    type: _media.actionTypes.CREATE,
    payload: payload
  };
};

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to update.
 */
exports.mediaShow = mediaShow;
var mediaUpdate = function mediaUpdate(data) {
  return {
    type: _media.actionTypes.UPDATE,
    payload: data
  };
};

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to update.
 */
exports.mediaUpdate = mediaUpdate;
var mediaThumbnail = function mediaThumbnail(data) {
  return {
    type: _media.actionTypes.THUMBNAIL,
    payload: data
  };
};

/**
 * Update
 * @param payload
 * @returns api response
 * @description this function used to update.
 */
exports.mediaThumbnail = mediaThumbnail;
var mediaThumbnailGet = function mediaThumbnailGet(data) {
  return {
    type: _media.actionTypes.THUMBNAILGET,
    payload: data
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete.
 */
exports.mediaThumbnailGet = mediaThumbnailGet;
var mediaDelete = function mediaDelete(payload) {
  return {
    type: _media.actionTypes.DELETE,
    payload: payload
  };
};

/**
 * delete
 * @param payload
 * @returns api response
 * @description this function used to delete.
 */
exports.mediaDelete = mediaDelete;
var mediaReset = function mediaReset(payload) {
  return {
    type: _media.actionTypes.RESET,
    payload: payload
  };
};
exports.mediaReset = mediaReset;